import '../../stylesheets/smart_phone/common.css'
import '../../stylesheets/smart_phone/flexslider.css'
import '../../stylesheets/smart_phone/original/product_show.css'
import '../../stylesheets/bootstrap5/icon_fonts.css'
